<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" lg="10" offset-lg="1">
        <v-btn color="primary" class="mb-4" dark tile @click="initializeOrder">
          新規発注作成
        </v-btn>

        <router-link :to="{ name: 'adminOrderRegistrations' }">
          <v-btn color="success" class="mb-4" dark tile> 一括発注登録 </v-btn>
        </router-link>
        <v-form @submit.prevent="searchOrders">
          <v-layout row>
            <v-text-field
              v-model="searchQuery.idEq"
              label="ID"
              style="max-width: 150px"
              type="number"
              clearable
              class="ma-2"
            />
            <v-text-field
              v-model="searchQuery.titleOrQueryCont"
              label="キーワード"
              style="max-width: 400px"
              clearable
              class="ma-2"
            />
            <v-text-field
              v-model="searchQuery.userNameCont"
              label="ライター名"
              style="max-width: 150px"
              clearable
              class="ma-2"
            />
            <v-select
              v-model="searchQuery.statusEq"
              :items="selectableOrderStatuses.filter(e => [0, 10, 30, 40].includes(e.value))"
              style="max-width: 150px"
              class="ma-2"
              clearable
              label="ステータス"
            />
            <v-btn
              color="primary"
              dark
              tile
              outlined
              class="ma-2"
              type="submit"
              @click="searchOrders"
              @submit.prevent="searchOrders"
            >
              検索
            </v-btn>
          </v-layout>
        </v-form>

        <order-table
          :orders="orders"
          @edit-order="editOrder"
          @delete-order="deleteOrder"
        />

        <infinite-loading
          spinner="spiral"
          class="mt-2"
          :identifier="infiniteId"
          @infinite="infiniteHandler"
        >
          <template v-slot:no-more>
            <v-chip label outlined> 全て表示されました。 </v-chip>
          </template>
          <template v-slot:no-results>
            <v-chip label outlined> 表示できるものがありません。 </v-chip>
          </template>
        </infinite-loading>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" persistent scrollable width="800">
      <order-form
        :order="editableOrder"
        :writers="writers"
        :regulation-bundlers="regulationBundlers"
        @change-order="editableOrder = order"
        @create-order="createOrder"
        @cancel-order="cancelOrder"
        @update-order="updateOrder"
        @cancel-edit="dialog = false"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import axios from 'axios'
import InfiniteLoading from 'vue-infinite-loading'
import Qs from 'qs'
import { mapState } from 'vuex'
import { deserialize } from 'deserialize-json-api'
import OrderTable from '@/components/commons/orders/Table'
import OrderForm from '@/components/commons/orders/Form'
import headUtilsMixin from '@/mixins/head_utils'
import orderUtilsMixin from '@/mixins/order_utils'
import { cloneDeep } from 'lodash'

export default {
  components: {
    InfiniteLoading,
    OrderTable,
    OrderForm
  },
  mixins: [headUtilsMixin, orderUtilsMixin],
  data: () => {
    return {
      pageTitle: '発注一覧',
      orders: [],
      page: 1,
      searchQuery: {
        titleOrQueryCont: null,
        idEq: '',
        statusEq: '',
        userNameCont: ''
      },
      infiniteId: +new Date(),
      editableOrder: {},
      editableRankKeywords: {},
      dialog: false,
      writers: [],
      regulationBundlers: []
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.UserStore.currentUser,
      orderI18ns: (state) => state.I18n.enums.order
    })
  },
  mounted () {
    const params = { params: { role: 'writer' } }
    axios.get('/api/users', params).then(({ data }) => {
      this.writers = deserialize(data).data
    })

    axios.get('/api/regulation_bundlers').then(({ data }) => {
      this.regulationBundlers = deserialize(data).data
    })
  },
  methods: {
    searchOrders () {
      this.page = 1
      this.orders = []
      this.infiniteId++
    },
    infiniteHandler ($state) {
      axios
        .get('/api/orders', {
          params: {
            page: this.page,
            q: this.searchQuery
          },
          paramsSerializer: function (params) {
            return Qs.stringify(params, { arrayFormat: 'brackets' })
          }
        })
        .then(({ data }) => {
          const fetchedOrders = deserialize(data).data
          if (fetchedOrders.length > 0) {
            this.page++
            this.orders = this.orders.concat(fetchedOrders)
            $state.loaded()
          } else {
            $state.complete()
          }
        })
    },
    editOrder (order) {
      this.editableOrder = cloneDeep(order)
      this.editableOrder.rankKeywords = cloneDeep(order.rankKeywords)
      this.dialog = true
    },
    initializeOrder () {
      this.editableOrder = {
        title: null,
        query: null,
        reccomend: null,
        regulationBundlerId: null,
        requiredWords: null,
        rankKeywords: {
          a: [],
          b: [],
          c: [],
          d: []
        },
        expiredOn: null,
        instruction: null,
        isRemanded: null,
        userId: null
      }
      this.dialog = true
    },
    createOrder (order) {
      this.$store.dispatch('LoaderStore/displayLoader')
      axios.post(`/api/orders`, { order }).then(
        () => {
          this.$store.dispatch('LoaderStore/hideLoader')
          this.dialog = false
          this.searchOrders()
          const payload = {
            status: 200,
            message: '発注を作成しました'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        },
        (error) => {
          this.$store.dispatch('LoaderStore/hideLoader')
          this.displayErrorMessage(error)
        }
      )
    },
    cancelOrder (order) {
      this.$store.dispatch('LoaderStore/displayLoader')

      axios.patch(`/api/orders/${order.id}/cancel`).then(
        ({ data }) => {
          this.$store.dispatch('LoaderStore/hideLoader')
          this.dialog = false
          const canceledOrder = deserialize(data).data
          Object.assign(
            this.orders.find((order) => order.id === canceledOrder.id),
            canceledOrder
          )
          const payload = {
            status: 200,
            message: '発注を初期化しました'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        },
        (error) => {
          this.$store.dispatch('LoaderStore/hideLoader')
          this.displayErrorMessage(error)
        }
      )
    },
    updateOrder (order) {
      this.$store.dispatch('LoaderStore/displayLoader')
      axios.patch(`/api/orders/${order.id}`, { order }).then(
        ({ data }) => {
          this.$store.dispatch('LoaderStore/hideLoader')
          this.dialog = false
          const updatedOrder = deserialize(data).data
          Object.assign(
            this.orders.find((order) => order.id === updatedOrder.id),
            updatedOrder
          )
          const payload = {
            status: 200,
            message: '発注を更新しました'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        },
        (error) => {
          this.$store.dispatch('LoaderStore/hideLoader')
          this.displayErrorMessage(error)
        }
      )
    },
    deleteOrder (order) {
      axios.delete(`/api/orders/${order.id}`).then(
        () => {
          const index = this.orders.findIndex((v) => v.id === order.id)
          this.orders.splice(index, 1)
          const payload = {
            status: 200,
            message: '発注を削除しました'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        },
        (error) => {
          this.displayErrorMessage(error)
        }
      )
    },
    displayErrorMessage (error) {
      const payload = {
        status: error.response.status,
        message: error.response.data.errors.toString()
      }
      this.$store.dispatch('SystemMessageStore/createMessage', payload)
    }
  }
}
</script>
